import { Element, InstallSpec, ItemComponent } from "../../../install/types.ts";

const CLIENT_ID_PATTERN = /^[a-zA-Z0-9]{12}CNTRL$/;

export const TailscaleComponents = InstallSpec({
  "iam-write": ItemComponent({
    label: "Tailscale policy management",
    description:
      "Allows P0 to manage access to your Tailscale network for your users.",
    type: "string",
    maturity: "beta",
    schema: {
      clientId: Element({
        label: "Client ID",
        type: "string",
        description: 'Client ID of Tailscale OAuth app with "all" scope',
        validator: async (_id, field) => {
          if (!field) {
            return "Please provide the client ID";
          }
          if (!field.trim().match(CLIENT_ID_PATTERN)) {
            return "Client ID must contain 17 alphanumeric characters and end in 'CNTRL'";
          }
        },
      }),
      clientSecret: Element({
        label: "Client secret",
        type: "encrypted",
        description: 'Client secret of Tailscale OAuth app with "all" scope',
        validator: async (_id, field) => {
          if (!field) {
            return "Please provide the client secret";
          }
          if (field.clearText?.trim() !== field.clearText) {
            return "Please remove leading and trailing whitespace from the client secret";
          }
          if (!field.clearText?.startsWith("tskey-client-")) {
            return "Please provide an OAuth client secret with 'tskey-client-' prefix";
          }
        },
      }),
    },
  }),
});
